<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="全部退换货订单">
        <allReturn />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="待提交退换货">
        <waitReturn />
      </rj-tab-pane>
      <rj-tab-pane name="3" label="待盖章退换货">
        <waitSeal />
      </rj-tab-pane>
      <rj-tab-pane name="4" label="待付款退换货">
        <waitPayment />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>

<script>
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import allReturn from './allReturn.vue';
import waitReturn from './waitReturn.vue';
import waitSeal from './waitSeal.vue';
import waitPayment from './waitPayment.vue';

export default {
  data () {
    return {
      tabsActive: '1'
    };
  },
  computed: {
    // tabsActive: {
    //   get () {
    //     return this.$store.state.pagesTemporary.ChiefOrderListTabActive;
    //   },
    //   set (val) {
    //     this.$store.commit('pagesTemporary/SETChiefOrderListTabActive', val);
    //   }
    // }
  },
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    allReturn,
    waitReturn,
    waitSeal,
    waitPayment

  }
};
</script>

<style>

</style>
